module.exports = __webpack_public_path__ + "img/animation_loading.90aec4b8.gif";